/* eslint-disable react/prop-types */
import { Collapse, ConfigProvider, Typography } from 'antd';

import ConsultSummary from './ConsultSummary';
import styles from './Review.css';

const Review = ({ feeContent, summary, doctor, consult }) => {
  const items = [
    {
      key: '1',
      label: <Typography.Title level={5}>Consult Summary</Typography.Title>,
      children: <ConsultSummary summary={summary} doctor={doctor} consult={consult} />,
    },
    {
      key: '2',
      label: <Typography.Title level={5}>Fee Breakdown</Typography.Title>,
      children: feeContent,
    },
  ];

  return (
    <ConfigProvider
      theme={{
        components: { Collapse: { contentPadding: 0, padding: 0, paddingContentVertical: 0 } },
      }}>
      <div className={styles.scrollAble}>
        <Collapse
          defaultActiveKey={['1']}
          items={items}
          ghost
          className={styles.container}
          expandIconPosition="end"
        />
      </div>
    </ConfigProvider>
  );
};

export default Review;
